import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as React from 'react'
import { Input, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap'

interface ISearchBarProps {
  className?: string
  onChange: (newValue: string) => any
  placeholder?: string
  size?: 'sm' | 'lg'
  style?: React.CSSProperties
  value: string
}

export default class SearchBar extends React.PureComponent<ISearchBarProps> {
  public render() {
    return (
      <div className={this.props.className} style={this.props.style}>
        <InputGroup>
          <Input
            bsSize={this.props.size}
            onChange={(e) => this.props.onChange(e.target.value)}
            placeholder={this.props.placeholder || 'Search'}
            value={this.props.value}
          />
          <InputGroupAddon addonType='append'>
            <InputGroupText>
              <FontAwesomeIcon icon={['fal', 'search']} fixedWidth />
            </InputGroupText>
          </InputGroupAddon>
        </InputGroup>
      </div>
    )
  }
}
